import { render } from "./Trans.vue?vue&type=template&id=4f03ae6c&scoped=true"
import script from "./Trans.vue?vue&type=script&lang=js"
export * from "./Trans.vue?vue&type=script&lang=js"

import "./Trans.vue?vue&type=style&index=0&id=4f03ae6c&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f03ae6c"]])

export default __exports__